module.exports = __webpack_public_path__ + "static/img/16.549a4f36.png";